const BonusProduction = () =>
    import("@/views/bonusProduction/BonusProduction");

const BonusProductionList = () =>
    import("@/views/bonusProduction/BonusProductionList");

const LiquidationQuery = () =>
    import("@/views/bonusProduction/LiquidationQuery");

const PreliquidationGeneration = () =>
    import("@/views/bonusProduction/PreliquidationGeneration");

const PreliquidationApproval = () =>
    import("@/views/bonusProduction/PreliquidationApproval");


export const BonusProductionListRoute = {
    path: "bonusProductionList",
    component: BonusProductionList,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",    
        breadcrumb: [
            {
                text: "Bonos por Producción",
                disabled: true,
                href: "#"
            },
            {
                text: "Consulta",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};

export const LiquidationQueryRoute = {
    path: "liquidationQuery",
    component: LiquidationQuery,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",       
        breadcrumb: [
            {
                text: "Comisiones",
                disabled: true,
                href: "#"
            },
            {
                text: "Consulta de liquidaciones",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};

export const PreliquidationGenerationRoute = {
    path: "preliquidationGeneration",
    component: PreliquidationGeneration,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",       
        breadcrumb: [
            {
                text: "Comisiones",
                disabled: true,
                href: "#"
            },
            {
                text: "Generacion de preliquidación",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};

export const PreliquidationApprovalRoute = {
    path: "preliquidationApproval",
    component: PreliquidationApproval,
    meta: {
        requiresAuth: true,
        title: "message.ecommerce",    
        breadcrumb: [
            {
                text: "Comisiones",
                disabled: true,
                href: "#"
            },
            {
                text: "Aprobación de preliquidaciones",
                disabled: false,
                href: "#"
            }
        ],
        scope:["aps_broker"]
    }
};


export const BonusProductionRoute = {
    path: "bonusProduction",
    component: BonusProduction,
    children: [

        BonusProductionListRoute,
        LiquidationQueryRoute,
        PreliquidationGenerationRoute,
        PreliquidationApprovalRoute,
    ]
}